import { RepairsUpdatesCommentsPostRequest } from './post'

export class RepairsUpdatesCommentsPutRequest extends RepairsUpdatesCommentsPostRequest {
  commentId!: string
  version!: number
}
